<template>
  <div class="create-rule-wrapper">
    <Menu v-if="!activeSection.isCreateRule" :activeSection="activeSection" @goBackToComponent="goBackToComponent"></Menu>
    <div id="no-mode-absolute-demo" class="demo">
      <div class="no-mode-absolute-demo-wrapper">
        <transition name="no-mode-absolute-fade">
          <div v-if="activeSection.isCreateRule">
            <h1 v-if="ruleKey">Edit Rule</h1><h1 v-else>New Rule</h1>
            <el-input class="new-rule" placeholder="Name of the rule" v-model="ruleInfo.name" clearable></el-input>
            <div v-if="contest && contest.sport">
            </div>
            <div v-else>
              <el-select class="botm-space top-space new-rule sport-drop" v-model="sport" placeholder="Select sport">
                <el-option
                  v-for="item in sports"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key">
                </el-option>
              </el-select>
            </div>
            <div class="contest-box" :class="ruleInfo.key ? 'disable' : ''">
              <div class="contest-box-inner">
                <h3>Buy in Chips</h3>
                <div class="rule-box">
                  <el-input class="new-rule" type="number" placeholder="0" v-model="ruleInfo.buy_in_chips" min=0 oninput="validity.valid||(value='');" clearable></el-input>
                </div>
                <h3>Participants</h3>
                <div class="rule-box participants">
                  <div class="left-block">
                    <el-input  type="number" min=0 oninput="validity.valid||(value='');" v-model="ruleInfo.min_participants" placeholder="0" clearable>
                    </el-input><span class="extra-label">MIN</span>
                  </div>
                  <div class="right-block">
                    <el-input  type="number" v-model="ruleInfo.max_participants" placeholder="∞" clearable>
                    </el-input><span class="extra-label">MAX</span>
                  </div>
                </div>
                <h3>Players per team</h3>
                <div class="rule-box players">
                  <div class="rule-box num-players">
                    <!-- Min participants -->
                    <label class="field" v-for="(player,index) in maxPlayersTeam" :key="index">
                      <h3 class="min-players numbers" :class="ruleInfo.min_players_per_team? 'hide': 'show'">{{player}}</h3>
                      <input v-if="ruleInfo.min_players_per_team == null" type="radio" name="default" :value="player" v-model="ruleInfo.min_players_per_team">
                      <input v-else type="radio" name="default" :value="player" v-model="ruleInfo.max_players_per_team">
                    </label>

                    <!-- selected Min Max participants -->
                    <span v-if="ruleInfo.min_players_per_team" @click="changeMinValue()"><span :class="ruleInfo.min_players_per_team? 'active' : ''" class="min-players box-width numbers">{{ruleInfo.min_players_per_team}}<div class="player-img"><img src="@/assets/imgs/player.svg"></div></span><div class="limit min">MIN</div>
                    </span>
                    <span class="hyphen" v-if="ruleInfo.min_players_per_team">-</span>
                    <span v-if="ruleInfo.max_players_per_team" @click="changeMaxValue()"><span :class="ruleInfo.max_players_per_team? 'active' : ''" class="min-players box-width numbers">{{ruleInfo.max_players_per_team}}<div class="player-img"><img src="@/assets/imgs/player.svg"></div></span><div class="limit min">MAX</div>
                    </span>

                    <!-- Max participants -->
                    <label class="field" :class="[player === ruleInfo.max_players_per_team ? 'active' : '']" v-for="(player,index) in maxPlayersTeam" :key="index[player]" v-if="ruleInfo.min_players_per_team && !ruleInfo.max_players_per_team">
                      <h3 class="min-players numbers" :class="parseInt(player) > ruleInfo.min_players_per_team ? 'show': 'hide'">{{player}}</h3>
                      <input v-if="!ruleInfo.max_players_per_team" type="radio" name="default" :value="player" v-model="ruleInfo.max_players_per_team">
                    </label>
                  </div>
                </div>
                <h3>Credits</h3>
                <div class="rule-box">
                  <el-input  min=0 oninput="validity.valid||(value='');" class="new-rule" type="number" placeholder="0" v-model="ruleInfo.credits" clearable></el-input>
                </div>
                <h3>Number of players</h3>
                <div class="rule-box participants">
                  <div class="left-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.min_players" clearable></el-input><span class="extra-label">MIN</span>
                  </div>
                  <div class="right-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.max_players" clearable></el-input><span class="extra-label">MAX</span>
                  </div>
                </div>
              </div>
            </div>
              <div class="contest-box" :class="ruleInfo.key ? 'disable' : ''">
              <div class="contest-box-inner">
                <h3>Number of matches</h3>
                <div class="rule-box participants">
                  <div class="left-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.min_matches" clearable></el-input><span class="extra-label">MIN</span>
                  </div>
                  <div class="right-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.max_matches" clearable></el-input><span class="extra-label">MAX</span>
                  </div>
                </div>

                <h3>Number of players per match</h3>
                <div class="rule-box participants">
                <div class="left-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.min_players_per_match" clearable></el-input><span class="extra-label">MIN</span>
                  </div>
                  <div class="right-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.max_players_per_match" clearable></el-input><span class="extra-label">MAX</span>
                  </div>
                </div>

                <h3>Number of teams</h3>
                <div class="rule-box participants">
                <div class="left-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.min_teams" clearable></el-input><span class="extra-label">MIN</span>
                  </div>
                  <div class="right-block">
                    <el-input placeholder="0" type="number" min=0 oninput="validity.valid||(value='');" class="new-rule" v-model="ruleInfo.max_teams" clearable></el-input><span class="extra-label">MAX</span>
                  </div>
                </div>
              </div>
            </div>
            <button class="confirm-btn small-btn" @click="showRoles()">Continue</button>
          </div>
        </transition>
        <transition name="no-mode-absolute-fade">
          <div class="min-max-roles" v-if="activeSection.isMinMaxRoles">
            <h1>Min and Max by Roles</h1>
            <div v-if="ruleInfo.key">
              <div class="contest-box" :class="ruleInfo.key ? 'disable' : ''" v-if="ruleInfo.max_players_by_role || ruleInfo.min_players_by_role">
                <div class="contest-box-inner" v-if="sport == 'cricket'">
                  <div v-for="(value,key) in ruleInfo.min_players_by_role" :key="key">
                    <h3>{{key | capitalise}}</h3>
                    <min-max-players-selection :rule="ruleInfo" :role="key"></min-max-players-selection>
                  </div>
                  <button class="reset-btn clean" @click="resetRoles"><span><img src="@/assets/imgs/reset.svg"></span>reset roles</button>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="contest-box">
                <div class="contest-box-inner" v-if="sport == 'cricket'">
                  <div v-for="key in cricketRoles" :key="key.key">
                    <h3>{{key.key | capitalise}}</h3>
                    <min-max-players-selection :rule="ruleInfo" :role="key.key"></min-max-players-selection>
                  </div>
                  <button class="reset-btn clean" @click="resetRoles"><span><img src="@/assets/imgs/reset.svg"></span>reset roles</button>
                </div>
                <div class="contest-box-inner" v-if="sport == 'football'">
                  <div v-for="key in footballRoles" :key="key.key">
                    <h3>{{key.key | capitalise}}</h3>
                    <min-max-players-selection :rule="ruleInfo" :role="key.key"></min-max-players-selection>
                  </div>
                  <button class="reset-btn clean" @click="resetRoles"><span><img src="@/assets/imgs/reset.svg"></span>reset roles</button>
                </div>
              </div>
            </div>
          
            <div class="content-box">
              <div class="img-box">
                <img src="@/assets/imgs/description.svg">
              </div>
              <div class="content">
                <h5>Notes</h5>
                <p v-if="ruleInfo.desc">{{ruleInfo.desc}}</p>
                <p v-else>Add notes about the rule this will be visible in the contest.</p>
                <p>
                  <button class="add-link" v-if="ruleInfo.desc" @click="showNotes = true">Edit</button>
                  <button class="add-link" v-else @click="showNotes = true">Add</button>
                </p>
                <AddTextPopup :payload="ruleInfo" :property="'desc'" @onClose="onClose" :show="showNotes"></AddTextPopup>
              </div>
            </div>
            <button class="create-btn" @click="saveRule()"><span v-if="ruleKey">Save</span><span v-else>Create Rule</span></button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { Enum } from '@/helpers/enum'
import { DataState, WizardManager } from '@/state'
import { Rule, participants } from '@/models/fantasyconsole/rule'
import MinMaxPlayersSelection from '@/components/fantasyconsole/MinMaxPlayersSelection'
import AddTextPopup from '@/components/fantasyconsole/AddTextPopup'

export const Step = new Enum({
  CreateRule: 'Create Rule',
  MinMaxRoles: 'Min and Max by Roles',
  BoostPlayers: 'Boost players',
  ContestClosingTime: 'Contest closing time'
})

export default {
  components: {
    MinMaxPlayersSelection,
    AddTextPopup
  },
  props: {
    ruleKey: null,
    contest: {
      type: Object
    }
  },
  data () {
    return {
      ruleManager: null,
      state: DataState.newNotInit(),
      sections: Step,
      activeSection: Step.CreateRule,
      ruleInfo: new Rule(),
      newRule: null,
      participants: participants,
      maxParticipants: '∞',
      showNotes: false,
      boostPlayersArr: [],
      maxPlayersTeam: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      sport: null,
      wizardManager: {},
      footballRoles: [
        { 'key': 'goalkeeper','value': null },
        { 'key': 'defender','value': null },
        { 'key': 'midfielder','value': null },
        { 'key': 'striker','value': null }
      ],
      cricketRoles : [
        { 'key': 'bowler','value':  null  }, 
        { 'key': 'batsman','value': null }, 
        { 'key': 'keeper','value':  null }, 
        { 'key': 'allrounder','value':  null }
      ],
      sports: [
        {
          'key': 'cricket',
          'name': 'Cricket'
        },
        {
          'key': 'football',
          'name': 'Football'
        }
      ]
    }
  },
  mounted () {
    this.wizardManager = JSON.parse(localStorage.getItem('wizardManager'))
    if (this.ruleKey) {
      this.onViewOpenned()
    } else {
      this.ruleInfo = new Rule()
      if (WizardManager.flow.length < 1) {
        this.getWizardmanager()
      }
    }
    if (this.contest && this.contest.sport) {
      this.sport = this.contest.sport
    } else {
      this.sport = null
    }

    this.contestWizard(this.activeSection, this.wizardManager.stateData)
    window.scrollTo(0, 0);
  },

  methods: {
    getWizardmanager () {
      if (this.wizardManager.flow.length > 1) {
        if (this.wizardManager.ChildWizard.flow.length == 0) {
          this.contestWizard(WizardManager.flow[WizardManager.flow.length - 1], this.wizardManager.stateData)
        }
        for (let section of this.wizardManager.ChildWizard.flow) {
          const found = WizardManager.ChildWizard.flow.some(e1 => e1.key === section.key)
          if (!found) {
            WizardManager.ChildWizard.flow.push(section)
          }
        }
        this.activeSection = Step[WizardManager.ChildWizard['flow'][WizardManager.ChildWizard.flow.length - 1]['key']]
        this.contest = this.wizardManager.stateData
        if (!this.contest.sport) {
          this.activeSection = Step.CreateRule
        }
        if (Object.keys(this.wizardManager.ChildWizard.stateData).length > 0) {
          this.ruleInfo = this.wizardManager.ChildWizard.stateData
        }
      } else {
        this.contestWizard(this.activeSection)
      }
    },
    onViewOpenned () {
      Rule.getRule(this.ruleKey).then((resp) => {
        this.ruleInfo = resp
        // this.getWizardmanager()
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    goBackToComponent (page) {
      this.activeSection = Step[page['key']]
    },
    showRoles () {
      if (this.ruleInfo.name && this.sport) {
        this.activeSection = Step.MinMaxRoles
        this.contestWizard(Step.MinMaxRoles, this.contest)
        window.scrollTo(0, 0); 
      } else if ((this.ruleInfo.name == null || this.ruleInfo.name == '') && this.sport){
        this.$notify({
          message: 'Name of the rule is missing!!',
          type: 'warning'
        })
      } else if (this.ruleInfo.name && this.sport == null) {
         this.$notify({
          message: 'Please select the sport!!',
          type: 'warning'
        })
      } else if (this.ruleInfo.min_players_per_team == null && this.ruleInfo.max_players_per_team == null) {
        this.$notify({
          message: 'Please select players per team!!',
          type: 'warning'
        })
      } else{
         this.$notify({
          title: 'Warning',
          message: 'Please fill the fields',
          type: 'warning'
        })
      }
    },
    changeMinValue () {
      this.ruleInfo.min_players_per_team = null
      this.ruleInfo.max_players_per_team = null
    },
    changeMaxValue () {
      this.ruleInfo.max_players_per_team = null
    },
    resetRoles () {
      this.ruleInfo.min_players_by_role = {}
      this.ruleInfo.max_players_by_role = {}
    },
    saveRule () {
      Rule.createRule(this.ruleInfo).then((resp) => {
        this.$notify({
          title: 'Success',
          message: 'Rule created successfully',
          type: 'success'
        })
        this.state.changeToLoaded()
        this.$emit('rulesaved')
      }).catch((error) => {
        this.state.changeToError(error)
        if (this.state.msg.response.data.error) {
          this.$notify({
            title: 'Error',
            message: this.state.msg.response.data.error.msg,
            type: 'error'
          })
        }
      })
    },
    onClose (payload, show) {
      this.showNotes = show
    },
    contestWizard (section, payload) {
      const found = WizardManager.ChildWizard.flow.some(e1 => e1.key === section.key)
      if (!found) {
        WizardManager.ChildWizard.flow.push(section)
      }
      WizardManager.ChildWizard.stateData = this.ruleInfo
      WizardManager.stateData = payload
      WizardManager.ChildWizard.currentFlowIndex = WizardManager.ChildWizard.flow.length - 1
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    }
  }
}
</script>
